import { BaseViewStore } from 'core/stores';

class FacilityOrderTemplateNewFlowInsuranceProductModalStore extends BaseViewStore {
    constructor(rootStore, componentProps) {
        super(rootStore);
        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
    }
}

export default FacilityOrderTemplateNewFlowInsuranceProductModalStore;
